/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { RadioInput } from '../form/RadioInput';
import { InitiativeData } from '../../types/initiative';
import { updateFn } from '../form/common';
import { SubmitButton } from '../button/SubmitButton';
import { BasicAlert } from '../alert/BasicAlert';
import G17Client from '../../services/G17Client';
import { Button } from 'reactstrap';

interface Props {
  initiative: InitiativeData;
  handleReload: () => void;
  onCancel: () => void;
}

enum TargetFilter {
  Materiality = 'materiality',
  Custom = 'custom',
}

const bubbleViewOptions = [
  {
    code: TargetFilter.Materiality,
    name: 'Industry materiality',
    instructions: ''
  },
  {
    code: TargetFilter.Custom,
    name: 'Custom materiality',
    instructions: ''
  },
];


interface SubmitState {
  loading: boolean;
  message: string,
  type: 'success' | 'danger';
}

export const ViewSelector = (props: Props) => {

  const { initiative, handleReload, onCancel } = props;
  const initiativeValue = initiative?.displaySettings?.targetActual?.view;
  const [value, setValue] = useState(initiativeValue);
  const [{ loading, type, message }, setSubmitData] = useState<SubmitState>({
    loading: false,
    type: 'success',
    message: '',
  });

  const onChange: updateFn = ({ value }) => {
    setValue(value);
  }

  const hasChanged = value && initiativeValue !== value;

  const updateView = async () => {
    if (!value) {
      return
    }
    setSubmitData({ loading: true, message: '', type: 'success' });
    G17Client.updateDisplaySettings(initiative._id, { targetActual: { view: value } })
      .then(() => {
        handleReload();
        setSubmitData({ loading: false, message: 'Success', type: 'success' });
      }).catch(e => {
        setSubmitData({ loading: false, message: e.message, type: 'danger' });
      })
  };

  return (
    <div>
      <BasicAlert type={type}>{message}</BasicAlert>
      <p>Choose your company's default Target view</p>
      <RadioInput
        groupCode={'view'}
        disabled={loading}
        options={bubbleViewOptions}
        value={value}
        onChange={onChange} />

      <div className='text-right mt-5'>
        <Button color='link-secondary' className='mr-3' onClick={onCancel}>Cancel</Button>
        <SubmitButton
          disabled={!hasChanged}
          onClick={updateView}>
          Save
        </SubmitButton>
      </div>
    </div>
  )
}
